/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';
import restClient from '../cart-service-apis/restClient';

/**
 * getSearchQAS
 *
 * docs - https://docs.experianaperture.io/address-validation/experian-address-validation/address-api-reference/api-specification/
 * url - https://api.experianaperture.io/address/format/v1
 *
 * @param {Object} args
 * @param {Object} args.payload
 * @param {String} args.payload.country_iso
 * @param {String} args.payload.global_address_key
 *
 * Example:
 *  payload = {
 *    country_iso: 'USA',
 *    global_address_key: 'xxxxxxxx', // key from QAS response on the search
 *  }
 *
  */

const getFormatQAS = (payload) => {
    const envObj = {
        protocol: 'https',
        host: mbpUtil.getEnv('APP_VERIFY_ADDRESS_HOST_V2') || 'api.experianaperture.io',
        rootUri: 'address',
        prefix: '/',
    };

    const resourcePage = `/format/v1/${payload.global_address_key}`;

    const headers = {
        'Auth-Token': mbpUtil.getEnv('APP_VERIFY_ADDRESS_AUTH_TOKEN') || '',
        'Add-Components': true,
        'Add-Metadata': true,
    };
    const params = { };

    return restClient.getRequest(envObj, resourcePage, 'InitialHeaders', params, headers, false)
        .then((response) => response);
};

export default getFormatQAS;
